import { ChevronDown } from '../../../../public/icons/Icons'
import { AudurButton } from '../../../components/audurButtons'
import { TranslatedStrings } from '../../../utils/translations/TranslatedStrings'

interface SettingsButtonProps {
	publicShowSettings: boolean
	setPublicShowSettings: (show: boolean) => void
}

const ShowMoreButton = ({ publicShowSettings, setPublicShowSettings }: SettingsButtonProps) => {
	return (
		<AudurButton variant='outlined' onClick={() => setPublicShowSettings(!publicShowSettings)}>
			{publicShowSettings
				? TranslatedStrings.is.newCalculator.hideSettings
				: TranslatedStrings.is.newCalculator.showSettings}
			<ChevronDown style={{ marginLeft: '8px' }} />
		</AudurButton>
	)
}

export default ShowMoreButton
